import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  constructor(private afdatabase: AngularFireDatabase) { }

  getMenuByUser(rol) {
    return this.afdatabase.object('/menu/' + rol);
  }
}
